import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './mass-validation.scss';
import { newToast } from '../../components';
import DataGrid, { Column, Grouping, KeyboardNavigation, Paging, Scrolling, Selection, Sorting, RemoteOperations } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { UseApiResults } from '../../api/api.results';
import { useAppDispatch, useAppSelector } from '../../contexts/hooks';
import { ResultEstadoResult, ResultFilterRequest, SysIResultados } from '../../types/types.orders';
import { useApiFunctionsResult } from '../../components/library/info-order/OrderModules/Functions/Results';
import { shallowEqual } from 'react-redux';
import { ResultTypeResult } from '../../types/types.analitos';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { Button, TagBox, Tooltip, DateRangeBox, SelectBox, LoadIndicator } from 'devextreme-react';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import Form, { Item as FormItem, Label } from 'devextreme-react/form';
import { btnSearch, filter, resButtonRefresh, resGridStatus3 } from '../../images/icons';
import CellComponent from '../../components/library/info-order/OrderModules/components/CellComponent';
import { ModalConfirmation } from '../../components';
import { KeyDownEvent } from 'devextreme/ui/data_grid';
import { ModalResultHistory } from '../../components/library/info-order/OrderModules/modals/ResultHistory';
import { ConvertLocalDate, ConvertDataOrder, ConvertDataPatient } from '../../utils/functions';
import { RightPanelControlled } from '../../components/utils/right-panel-controlled/RighPanel';
import moment from 'moment';
import { useApiOrders } from '../../api/api.orders';
import { StudiesSearchSelect, StudyItem, ProfileItem } from '../../components/library/info-order/OrderModules/components';
import { ModalNotes } from '../../components/utils/modal-notes/ModalNotes';
import { showModalNotes } from '../../contexts/slices/orders';
import { OrderInfo, PatientInfo } from '../../components/library/order-patient-info';
import { useScreenSize } from '../../utils/media-query';

const Index = () => {
  //#region VARIABLES Y ESTADOS
  const { getResultsForValMasive, validateResult, putInValidationNote } = UseApiResults();
  const { handleValRef, handleHistory, handleNote, handleStatusResult, handleSample, handlePreview2, handlePreview1, checkAlarmAndAburdNoLabel } = useApiFunctionsResult();
  const { getHeaderOrderById, findOrder } = useApiOrders();
  const gridRef = useRef<DataGrid>(null);
  const ModalNotesValidation = useAppSelector((x) => x.globalOrders.CurrentOrder.ModalNoteVal);
  const [dateRange, setDateRange] = useState<[Date, Date]>([new Date(), new Date()]);
  const [selectedAreas, setSelectedAreas] = useState<number[]>([]);
  const [modalConfirmation, setModalConfirmation] = useState<{ visible: boolean; message: string }>({ visible: false, message: '' });
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0); // Contador para disparar refresh
  const [resultFilter, setResultFilter] = useState<'normales' | 'alterados' | 'todos'>('normales'); // Filtro local por valores de referencia
  const [isPanelOpen, setIsPanelOpen] = useState<boolean>(false);
  const [currentOrder, setCurrentOrder] = useState<any>(null);
  const [currentPatient, setCurrentPatient] = useState<any>(null);
  const [loadingPanel, setLoadingPanel] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  // Estado para el filtro de estudios y perfiles
  const [selectedStudy, setSelectedStudy] = useState<StudyItem | null>(null);
  const [selectedProfile, setSelectedProfile] = useState<ProfileItem | null>(null);

  // Refs para los filtros que realmente se usan en la API
  const appliedDateRangeRef = useRef<[Date, Date]>([new Date(), new Date()]);
  const appliedAreasRef = useRef<number[]>([]);
  const appliedStudiosRef = useRef<number[]>([]);

  // Ref para almacenar las filas seleccionadas (evita re-render al seleccionar)
  const selectedRowsRef = useRef<any[]>([]);

  // Ref para almacenar los datos cargados desde la API
  const loadedDataRef = useRef<SysIResultados[]>([]);
  const { isXSmall, isMedium, isLarge } = useScreenSize();
  const currentLocation = useAppSelector((x) => x.userInfo.Location, shallowEqual);
  const Prm_Res_Val_OtrSd = useAppSelector((x) => x.userInfo.Permissions?.Prm_Res_Val_OtrSd, shallowEqual) ?? false;
  const Prm_ResValidar = useAppSelector((x) => x.userInfo.Permissions?.Prm_ResValidar, shallowEqual) ?? false;
  const Prm_Res_Conf = useAppSelector((x) => x.userInfo.Permissions?.Prm_Res_Conf, shallowEqual) ?? false;
  const Prm_Res_Val_Crit = useAppSelector((x) => x.userInfo.Permissions?.Prm_Res_Val_Crit, shallowEqual) ?? false;
  const ModuleWarnings: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleWarnings')[0].Cgn_Resultado, shallowEqual) || 'false');
  const MaxCountRegs: number = parseInt(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'MaxCountRegs')[0]?.Cgn_Resultado, shallowEqual) || '0');
  const modeEditor = useAppSelector((x) => x.configuration.IsEditing, shallowEqual);
  const Areas = useAppSelector((x) => x.configuration.Data?.Areas, shallowEqual) || [];
  const [groupByArea, setGroupByArea] = useState<boolean>(true);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [totalApiRecords, setTotalApiRecords] = useState<number>(0); // Total de registros que retornó la API
  const [modalFiltersVisible, setModalFiltersVisible] = useState<boolean>(true); // Abre modal de filtros al entrar
  const [dataLoaded, setDataLoaded] = useState<boolean>(false); // Controla si ya se cargaron datos
  const [appliedFiltersText, setAppliedFiltersText] = useState<string>(''); // Texto con los filtros aplicados
  //#endregion

  //#region HELPER FUNCTIONS
  // Función para extraer el valor numérico de strings como ">1000" o "<500"
  const extractNumericValue = (value: string): number | null => {
    if (!value) return null;
    const cleaned = String(value).trim();
    // Remover > o < del inicio y convertir a número
    const numStr = cleaned.replace(/^[><]\s*/, '');
    const num = parseFloat(numStr);
    return isNaN(num) ? null : num;
  };

  // Función para determinar si un resultado está alterado
  const isResultAltered = useCallback((result: SysIResultados): boolean => {
    // Solo aplica para numéricos y fórmulas
    if (result.Analito.An_Tr_Id !== ResultTypeResult.NUMERICO && result.Analito.An_Tr_Id !== ResultTypeResult.FORMULA) {
      return false;
    }

    if (!result.Res_Resultado) {
      return false;
    }

    // Extraer el número del resultado (manejar casos como >1000 o <500)
    const resultString = String(result.Res_Resultado).trim();
    const numericValue = extractNumericValue(resultString);
    if (numericValue === null || isNaN(numericValue)) {
      return false;
    }

    // Obtener valores de referencia
    const minValue = result.Res_ValRefMin != null ? parseFloat(result.Res_ValRefMin.toString()) : null;
    const maxValue = result.Res_ValRefMax != null ? parseFloat(result.Res_ValRefMax.toString()) : null;

    // Si no hay valores de referencia, no se considera alterado
    if (minValue === null && maxValue === null) {
      return false;
    }

    // Detectar si tiene símbolo de comparación
    const hasGreaterThan = resultString.startsWith('>');
    const hasLessThan = resultString.startsWith('<');

    // Si tiene >, el valor real es mayor que el número mostrado
    // Comparar con el límite superior
    if (hasGreaterThan) {
      if (maxValue !== null && numericValue > maxValue) {
        return true;
      }
      return false;
    }

    // Si tiene <, el valor real es menor que el número mostrado
    // Comparar con el límite inferior
    if (hasLessThan) {
      if (minValue !== null && numericValue < minValue) {
        return true;
      }
      return false;
    }

    // Sin símbolos, comparación normal
    // Verificar si está fuera del rango
    if (minValue !== null && numericValue < minValue) {
      return true;
    }
    if (maxValue !== null && numericValue > maxValue) {
      return true;
    }

    return false;
  }, []);
  //#endregion

  //#region DATASOURCE
  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Res_Id',
      load: () => {
        // No cargar datos hasta que el usuario aplique filtros
        if (!dataLoaded) {
          return Promise.resolve({ data: [], totalCount: 0 });
        }
        const data: ResultFilterRequest = {
          states: [ResultEstadoResult.ConResultado], // Solo estado 2: Con resultado
          areas: appliedAreasRef.current,
          studies: appliedStudiosRef.current,
        };
        // Convertir fechas restando 5 horas usando los refs actuales
        const adjustedStartDate = new Date(ConvertLocalDate(appliedDateRangeRef.current[0]));
        const adjustedEndDate = new Date(ConvertLocalDate(appliedDateRangeRef.current[1]));

        return getResultsForValMasive(adjustedStartDate, adjustedEndDate, data)
          .then((res) => {
            // La API devuelve un array directamente
            const dataArray = Array.isArray(res) ? res : [];

            // Almacenar los datos en el ref
            loadedDataRef.current = dataArray;

            // Guardar el total de registros que retornó la API (antes de filtrar)
            setTotalApiRecords(dataArray.length);

            // Aplicar filtro local según el tipo de resultado
            let filteredData = dataArray;
            if (resultFilter === 'normales') {
              filteredData = dataArray.filter((item: SysIResultados) => {
                const isNumericOrFormula = item.Analito.An_Tr_Id === ResultTypeResult.NUMERICO || item.Analito.An_Tr_Id === ResultTypeResult.FORMULA;
                return isNumericOrFormula && !isResultAltered(item);
              });
            } else if (resultFilter === 'alterados') {
              filteredData = dataArray.filter((item: SysIResultados) => {
                const isNumericOrFormula = item.Analito.An_Tr_Id === ResultTypeResult.NUMERICO || item.Analito.An_Tr_Id === ResultTypeResult.FORMULA;
                return isNumericOrFormula && isResultAltered(item);
              });
            }

            // Actualizar el contador de registros filtrados (visibles)
            setTotalRecords(filteredData.length);

            return {
              data: filteredData,
              totalCount: filteredData.length,
            };
          })
          .catch(() => {
            throw new Error('Error de carga de datos');
          });
      },
    });
  }, [resultFilter, isResultAltered, dataLoaded]); // Dependencias para que el store se actualice cuando cambie el filtro

  const customDataSrc = useMemo(() => {
    return new DataSource({
      store: customData,
      reshapeOnPush: false,
    });
  }, [customData]); // Dependencia del customData para recrear el DataSource cuando cambie
  //#endregion

  //#region EFFECTS
  useEffect(() => {
    // Solo refrescar cuando refreshTrigger cambie (cuando se aplique filtro)
    if (refreshTrigger > 0) {
      gridRef.current?.instance.refresh();
    }
  }, [refreshTrigger]);

  useEffect(() => {
    // Refrescar cuando cambie el filtro local de resultados
    gridRef.current?.instance.refresh();
  }, [resultFilter]);
  //#endregion

  //#region HANDLERS
  const handleKeys = (event: KeyDownEvent) => {
    if (event.event?.key === 'F3') {
      handleClickValidateResult();
      event.event.preventDefault();
    }
  };

  const handleRefresh = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  // Handler para cuando se selecciona un estudio
  const handleStudySelected = useCallback((study: StudyItem | null) => {
    setSelectedStudy(study);
    setSelectedProfile(null); // Limpiar perfil si se selecciona un estudio
  }, []);

  const handleApplyFilters = useCallback(() => {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      // Actualizar los refs con los nuevos valores
      appliedDateRangeRef.current = [dateRange[0], dateRange[1]];
      appliedAreasRef.current = selectedAreas;

      // Actualizar estudios desde el estudio o perfil seleccionado
      if (selectedProfile) {
        // Si hay un perfil seleccionado, obtener todos los estudios del perfil
        const profileStudies = selectedProfile.originalData?.SysI_Estudios?.map((e: any) => e.Es_Id) || [];
        appliedStudiosRef.current = profileStudies;
      } else if (selectedStudy) {
        // Si solo hay un estudio seleccionado
        appliedStudiosRef.current = [Number(selectedStudy.id)];
      } else {
        // Si no hay nada seleccionado, limpiar
        appliedStudiosRef.current = [];
      }

      // Construir texto de filtros aplicados
      const parts: string[] = [];
      parts.push(`${moment(dateRange[0]).format('DD/MM/YYYY')} - ${moment(dateRange[1]).format('DD/MM/YYYY')}`);
      if (selectedAreas.length > 0) {
        const areaNames = selectedAreas.map((id) => Areas.find((a) => a.Aa_Id === id)?.Aa_Nombre).filter(Boolean);
        parts.push(`Áreas: ${areaNames.join(', ')}`);
      }
      if (selectedStudy) {
        parts.push(`Estudio: ${selectedStudy.name}`);
      } else if (selectedProfile) {
        parts.push(`Perfil: ${selectedProfile.name}`);
      }
      setAppliedFiltersText(parts.join(' | '));

      // Marcar que ya se pueden cargar datos y cerrar modal
      setDataLoaded(true);
      setModalFiltersVisible(false);

      // Incrementar el trigger para disparar el refresh
      setRefreshTrigger((prev) => prev + 1);
    } else {
      newToast('WARNING', 'Por favor seleccione un rango de fechas válido', 3);
    }
  }, [dateRange, selectedAreas, selectedStudy, selectedProfile, Areas]);

  const handleDateRangeChange = useCallback((e: any) => {
    const value = e.value;
    if (value && value.length === 2 && value[0] && value[1]) {
      setDateRange([value[0], value[1]]);
    }
  }, []);

  const handleAreasChange = useCallback((e: any) => {
    setSelectedAreas(e.value || []);
  }, []);

  const handleModalShowFilter = useCallback(() => {
    setModalFiltersVisible(!modalFiltersVisible);
  }, [modalFiltersVisible]);

  const handleResultFilterChange = useCallback((e: any) => {
    setResultFilter(e.value);
  }, []);

  // Handler para selección de filas - almacena en ref sin causar re-render
  const handleSelectionChanged = useCallback((e: any) => {
    selectedRowsRef.current = e.selectedRowsData || [];
  }, []);

  const handleConfirmationValidateCriticos = useCallback(
    async (value: boolean) => {
      setModalConfirmation({ visible: false, message: '' });
      let info: SysIResultados[] = selectedRowsRef.current as SysIResultados[];
      let keysCriticals: number[] = [];

      let keys = await info
        ?.filter((x) => x.Res_Estado === ResultEstadoResult.ConResultado)
        .map((x) => {
          return x.Res_Id;
        });

      if (!value) {
        for (let i = 0; i < info.length; i++) {
          const element = info[i];
          if (element.Analito.An_Tr_Id === ResultTypeResult.NUMERICO || element.Analito.An_Tr_Id === ResultTypeResult.FORMULA || element.Analito.An_Tr_Id === ResultTypeResult.TEXTUAL || element.Analito.An_Tr_Id === ResultTypeResult.LISTA || element.Analito.An_Tr_Id === ResultTypeResult.AUTOCOMPLETAR) {
            if (checkAlarmAndAburdNoLabel(element)) {
              keysCriticals.push(element.Res_Id);
            }
          }
        }
        newToast('INFO', 'Se excluyeron resultados críticos', 4);
        keys = keys.filter((x) => !keysCriticals.includes(x));
      }

      if (!keys || keys.length === 0) {
        newToast('INFO', 'Debe seleccionar un elemento válido para validar', 4);
        return;
      }

      await validateResult({ keys, action: ResultEstadoResult.Validado });
      gridRef.current?.instance.clearSelection();
      gridRef.current?.instance.refresh();
    },
    [modalConfirmation, validateResult, checkAlarmAndAburdNoLabel]
  );

  const handleClickValidateResult = useCallback(async () => {
    try {
      if (!Prm_ResValidar) {
        newToast('INFO', 'No cuenta con los permisos para validar resultados', 5);
        return;
      }

      await gridRef.current?.instance.beginCustomLoading('');
      let info: SysIResultados[] = (await gridRef.current?.instance.getSelectedRowsData()) as SysIResultados[];

      //Sacamos las sedes de info que no sean iguales a la actual
      const locationsDif = info.filter((x) => x.Orden.Ord_Sd_Id !== currentLocation?.Location);

      if (locationsDif.length > 0 && !Prm_Res_Val_OtrSd) {
        newToast('INFO', 'No cuenta con los permisos para validar resultados de otras sedes', 5);
        return;
      }

      //Eliminamos los resultados que no están en estado 2
      info = info.filter((x) => x.Res_Estado === ResultEstadoResult.ConResultado);
      if (info.length === 0) {
        return;
      }
      let keysCriticals: number[] = [];
      //Validamos si hay resultados confidenciales y si tiene permisos de ver y validar resultados confidenciales
      if (info?.filter((x) => x.Estudio.Es_Confidencial && !Prm_Res_Conf)) {
        info = info.filter((x) => !x.Estudio.Es_Confidencial);
      }

      //Luego validamos que no hayan resultados criticos.
      if (ModuleWarnings) {
        for (let i = 0; i < info.length; i++) {
          const element = info[i];
          if (element.Analito.An_Tr_Id === ResultTypeResult.NUMERICO || element.Analito.An_Tr_Id === ResultTypeResult.FORMULA || element.Analito.An_Tr_Id === ResultTypeResult.TEXTUAL || element.Analito.An_Tr_Id === ResultTypeResult.LISTA || element.Analito.An_Tr_Id === ResultTypeResult.AUTOCOMPLETAR) {
            if (checkAlarmAndAburdNoLabel(element)) {
              keysCriticals.push(element.Res_Id);
            }
          }
        }
      }

      //Validamos si hay críticos
      if (keysCriticals.length > 0 && ModuleWarnings) {
        if (Prm_Res_Val_Crit) {
          setModalConfirmation({ visible: true, message: 'Desea validar los resultados críticos para los analitos seleccionados' });
          return;
        }
        newToast('WARNING', 'Usted no cuenta con permisos para validar resultados críticos', 4);
        await handleConfirmationValidateCriticos(false);
        return;
      }
      await handleConfirmationValidateCriticos(true);
    } finally {
      await gridRef.current?.instance.endCustomLoading();
    }
  }, [Prm_ResValidar, Prm_Res_Conf, Prm_Res_Val_OtrSd, Prm_Res_Val_Crit, ModuleWarnings, currentLocation, handleConfirmationValidateCriticos]);

  const handleConfirValidateCritical = useCallback(() => {
    handleConfirmationValidateCriticos(true);
  }, [handleConfirmationValidateCriticos]);

  const handleCancelValidateCritical = useCallback(() => {
    handleConfirmationValidateCriticos(false);
  }, [handleConfirmationValidateCriticos]);

  const handleGroupRowAr = useCallback((rowData) => {
    try {
      const itemRow = rowData.data.items[0].key ? rowData.data.items[0].items[0].Area.Aa_Nombre : rowData.data.items[0].Area.Aa_Nombre;
      return (
        <div
          onClick={() => {
            let items;
            if (rowData.data.items[0].key) {
              items = rowData.data.items.flatMap((subArray) => subArray.items.map((objeto) => objeto.Res_Id));
            } else {
              items = rowData.data.items.map((objeto) => objeto.Res_Id);
            }
            gridRef.current?.instance.deselectAll().then(() => {
              gridRef.current?.instance.selectRows(items, true);
            });
          }}>
          {itemRow}
        </div>
      );
    } catch (error) {
      return <div></div>;
    }
  }, []);

  // Handler para cargar datos de la orden al hacer clic en la columna ORDEN
  const handleOrderClick = useCallback(
    async (orderId: number) => {
      setIsPanelOpen(true);
      setLoadingPanel(true);

      try {
        const res = await getHeaderOrderById(orderId);

        if (res) {
          const { Orden, Paciente } = res;
          const convertedData = ConvertDataPatient(Paciente);
          const convertedOrder = ConvertDataOrder(Orden);

          setCurrentOrder(convertedOrder);
          setCurrentPatient(convertedData);
        } else {
          setCurrentOrder(null);
          setCurrentPatient(null);
          newToast('WARNING', 'No se encontró información de la orden', 3);
        }
      } catch (error) {
        console.error('Error al cargar orden:', error);
        newToast('ERROR', 'Error al cargar los datos de la orden', 3);
        setCurrentOrder(null);
        setCurrentPatient(null);
      } finally {
        setLoadingPanel(false);
      }
    },
    [getHeaderOrderById]
  );

  // Handler para cerrar el panel y limpiar datos
  const handleClosePanel = useCallback(() => {
    setIsPanelOpen(false);
    setCurrentOrder(null);
    setCurrentPatient(null);
  }, []);

  // Handler para ir a la orden
  const handleClickViewOrder = useCallback(() => {
    if (currentOrder) {
      findOrder(undefined, currentOrder.Ord_Id, setLoading, true);
    }
  }, [currentOrder, findOrder]);

  // Render personalizado para la columna ORDEN con clic
  const renderOrderCell = useCallback(
    (cellData) => {
      return (
        <div style={{ cursor: 'pointer', color: '#337ab7', textDecoration: 'underline' }} onClick={() => handleOrderClick(cellData.data.Res_Ord_Id)}>
          {cellData.data.Orden.Ord_Numero}
        </div>
      );
    },
    [handleOrderClick]
  );

  //#endregion

  //#region NOTAS VALIDACION
  const handleConfirmNotesValidation = useCallback(
    (note: string) => {
      if (!ModalNotesValidation) {
        return;
      }
      dispatch(showModalNotes({ Visible: false, An_Id: -1, Res_Estado: ResultEstadoResult.Validado, Res_Id: -1, Res_Resultado: '', An_Nombre: '', Update: false, Pc_Id: -1 }));
      putInValidationNote(ModalNotesValidation?.Res_Id, note).then((res) => {
        if (res) {
          newToast('SUCCESS', 'Nota registrada correctamente', 5);
          gridRef.current?.instance.refresh();
        }
      });
    },
    [ModalNotesValidation]
  );

  const handleCancelNotesValidation = useCallback(() => {
    dispatch(showModalNotes({ Visible: false, An_Id: -1, Res_Estado: ResultEstadoResult.Validado, Res_Id: -1, Res_Resultado: '', An_Nombre: '', Update: false, Pc_Id: -1 }));
  }, [ModalNotesValidation]);
  //#endregion

  const handleCombinedActions = useCallback(
    (cellData) => {
      // Estilos en línea para el contenedor
      const containerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '2px',
        width: '100%',
        height: '100%',
      };

      // Obtener los elementos renderizados por las funciones originales
      const historyElement = handleHistory(cellData);
      const noteElement = handleNote(cellData);

      // Crear un contenedor para ambos elementos con estilos en línea
      return (
        <div style={containerStyle}>
          {historyElement}
          {noteElement}
        </div>
      );
    },
    [handleHistory, handleNote]
  );

  return (
    <div className='view crm-contact-list'>
      <div className='view-wrapper-contact-list'>
        <div className='view-wrapper-mass-validation' style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
          <ModalConfirmation visible={modalConfirmation.visible} buttons='No/Yes' onConfirm={handleConfirValidateCritical} onCancel={handleCancelValidateCritical} message={modalConfirmation.message} />
          <ModalResultHistory />
          <ModalNotes visible={(ModalNotesValidation && ModalNotesValidation?.Visible) || false} type='Validation' state={ModalNotesValidation?.Res_Estado} currentNote={(ModalNotesValidation && ModalNotesValidation.Res_Resultado) || ''} onConfirm={handleConfirmNotesValidation} onCancel={handleCancelNotesValidation} />
          <div className='toolbar-mass-validation'>
            <Toolbar>
              <Item location='before' visible={isLarge || isMedium}>
                <div className='grid-header'>Validación Masiva</div>
              </Item>
              {appliedFiltersText && (
                <Item location='before' locateInMenu='auto'>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '0 8px' }}>
                    <span style={{ fontSize: '12px', color: '#888', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '500px' }}>{appliedFiltersText}</span>
                  </div>
                </Item>
              )}

              <Item location='after' locateInMenu='auto'>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '0 10px', minWidth: 'fit-content' }}>
                  <span style={{ fontSize: '13px', color: '#666', whiteSpace: 'nowrap' }}>
                    Registros: <strong>{totalRecords}</strong>
                    {totalApiRecords > totalRecords && <span style={{ fontSize: '11px', color: '#999', marginLeft: '4px' }}>(de {totalApiRecords})</span>}
                  </span>
                  {totalApiRecords >= MaxCountRegs && MaxCountRegs > 0 && (
                    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                      <i className='dx-icon-warning' id='WarningMaxRegs' style={{ color: '#ff9800', fontSize: '18px', cursor: 'pointer', display: 'block' }}></i>
                      <Tooltip target={'#WarningMaxRegs'} showEvent='mouseenter' hideEvent='mouseleave' position={'bottom'}>
                        <div style={{ textAlign: 'left', lineHeight: '1.4' }}>
                          <div>
                            La consulta ha alcanzado el límite máximo de <strong>{MaxCountRegs}</strong> registros.
                          </div>
                          <div>Posiblemente existan más resultados. Se recomienda validar estos registros primero o</div>
                          <div>aplicar un filtro más específico para garantizar la estabilidad del sistema.</div>
                        </div>
                      </Tooltip>
                    </div>
                  )}
                </div>
              </Item>
              <Item location='after' locateInMenu='auto'>
                <div className='separator' />
              </Item>
              <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton' visible={Prm_ResValidar}>
                <Button id='ValidarResultMasivo' icon={resGridStatus3} text='Validar elementos seleccionados' onClick={handleClickValidateResult} stylingMode='text' />
                <Tooltip target={'#ValidarResultMasivo'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                  Validar resultados seleccionados (F3)
                </Tooltip>
              </Item>
              <Item location='after' locateInMenu='auto'>
                <div className='separator' />
              </Item>
              <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                <Tooltip target='.filter-button-mv' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                  Filtrar resultados
                </Tooltip>
                <Button className='filter-button-mv' icon={filter} text='Filtrar' stylingMode='text' onClick={handleModalShowFilter} />
              </Item>
              <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                <Button id='RefrescarMasivo' icon={resButtonRefresh} text='Actualizar' stylingMode='text' onClick={handleRefresh} />
                <Tooltip target={'#RefrescarMasivo'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                  Refrescar datos
                </Tooltip>
              </Item>
              <Item location='after' locateInMenu='auto'>
                <div className='separator' />
              </Item>
              <Item location='after' locateInMenu='auto'>
                <SelectBox
                  value={resultFilter}
                  onValueChanged={handleResultFilterChange}
                  items={[
                    { value: 'normales', text: 'Normales' },
                    { value: 'alterados', text: 'Alterados' },
                    { value: 'todos', text: 'Todos' },
                  ]}
                  displayExpr='text'
                  valueExpr='value'
                  width={120}
                  stylingMode='outlined'
                  placeholder='Filtrar resultados'
                />
              </Item>
            </Toolbar>
          </div>

          <div id='gridContainer' style={{ flex: 1, overflow: 'auto', paddingBottom: '40px' }}>
            <DataGrid onKeyDown={handleKeys} onSelectionChanged={handleSelectionChanged} hoverStateEnabled className='gridResult' height={'100%'} dataSource={customDataSrc} ref={gridRef} width={'100%'} repaintChangesOnly={false} highlightChanges={false} rowAlternationEnabled={false} showColumnLines={true} cacheEnabled={false}>
              <RemoteOperations />
              <Selection mode='multiple' selectAllMode='page' showCheckBoxesMode='always' />
              {groupByArea && <Grouping autoExpandAll={true} allowCollapsing={false} />}
              <Scrolling mode='standard' showScrollbar='always' useNative={true} scrollByContent={true} />
              <Sorting mode='multiple' />
              <KeyboardNavigation editOnKeyPress={false} enterKeyAction='moveFocus' enterKeyDirection='row' />
              <Paging enabled={false} />

              <Column allowGrouping={false} allowSorting={false} caption='ID' allowEditing={false} visible={modeEditor} dataField='Res_Id' width={75} alignment='center' />
              {groupByArea && <Column caption='ÁREA' visible={false} allowEditing={false} groupIndex={0} calculateGroupValue={'Area.Aa_OrdenImpresion'} dataField='Area.Aa_Nombre' groupCellRender={handleGroupRowAr} />}
              <Column allowGrouping={false} allowSorting={false} caption='TIPO' cellRender={handleSample} allowEditing={false} dataField='Analito.TipoMuestra.Tm_Color' width={45} alignment='right' />
              <Column allowGrouping={false} allowSorting={false} caption='ACCIONES' allowEditing={false} width={75} alignment='center' cellRender={handleCombinedActions} />
              <Column allowGrouping={false} allowSorting={true} caption='EST.' showInColumnChooser={false} cellRender={handleStatusResult} allowEditing={false} dataField='Res_Estado' width={48} alignment='center' />
              <Column allowGrouping={false} allowSorting={true} caption='ORDEN' showInColumnChooser={false} allowEditing={false} dataField='Orden.Ord_Numero' width={80} alignment='center' cellRender={renderOrderCell} />
              <Column allowGrouping={false} allowSorting={true} caption='ESTUDIO' alignment='center' width={80} showInColumnChooser={false} allowEditing={false} dataField='Estudio.Es_Abreviatura' />
              <Column allowGrouping={false} allowSorting={true} caption='ANALITO' minWidth={150} showInColumnChooser={false} allowEditing={false} dataField='Analito.An_Nombre' />
              <Column allowGrouping={false} allowSorting={false} caption='RESULTADO' showInColumnChooser={false} dataField='Res_Resultado' allowEditing={false} dataType='object' cellComponent={CellComponent} alignment='center' width={140} />
              <Column allowGrouping={false} allowSorting={false} caption='PREVIO 1' allowEditing={false} dataField='Res_ResultadoPrevio1' alignment='center' width={90} cellRender={handlePreview1} />
              <Column allowGrouping={false} allowSorting={false} caption='PREVIO 2' allowEditing={false} dataField='Res_ResultadoPrevio2' alignment='center' width={90} cellRender={handlePreview2} />
              <Column allowGrouping={false} allowSorting={false} caption='UNIDAD' allowEditing={false} dataField='Res_UnidadMedida' alignment='center' width={90} />
              <Column allowGrouping={false} allowSorting={false} caption='REFERENCIA' allowEditing={false} alignment='center' width={99} cellRender={handleValRef} />
            </DataGrid>
          </div>
        </div>
        <RightPanelControlled isVisible={isPanelOpen} isPinned={false} onClose={handleClosePanel} includePin={false} title='Consulta de Orden'>
          {loadingPanel ? (
            <div style={{ padding: '30px', textAlign: 'center' }}>
              <LoadIndicator visible={true} />
              <div style={{ marginTop: '15px', color: '#666' }}>Cargando información...</div>
            </div>
          ) : (
            <>
              <OrderInfo orderData={currentOrder} />
              <PatientInfo patientData={currentPatient} />
              <div style={{ padding: '15px', borderTop: '1px solid #e0e0e0' }}>
                <Button text='IR A LA ORDEN' type='default' stylingMode='contained' width='100%' onClick={handleClickViewOrder} disabled={!currentOrder || loading} />
              </div>
            </>
          )}
        </RightPanelControlled>
        {modalFiltersVisible && (
          <Popup title='Filtrar resultados' visible={modalFiltersVisible} showCloseButton={true} onHiding={handleModalShowFilter} fullScreen={isXSmall} width={isXSmall ? 360 : 500} wrapperAttr={{ class: 'form-popup' }} height='auto'>
            <Form colCount={1} labelLocation='top'>
              <FormItem
                editorType='dxDateRangeBox'
                editorOptions={{
                  value: dateRange,
                  onValueChanged: handleDateRangeChange,
                  displayFormat: 'dd/MM/yyyy',
                }}>
                <Label text='Fecha' />
              </FormItem>
              <FormItem
                editorType='dxTagBox'
                editorOptions={{
                  value: selectedAreas,
                  items: Areas,
                  displayExpr: 'Aa_Nombre',
                  valueExpr: 'Aa_Id',
                  showSelectionControls: true,
                  showClearButton: true,
                  showDataBeforeSearch: true,
                  onValueChanged: handleAreasChange,
                  applyValueMode: 'useButtons',
                  searchEnabled: true,
                  minSearchLength: 2,
                  searchTimeout: 200,
                }}>
                <Label text='Áreas' />
              </FormItem>
              <FormItem
                cssClass='full-width-item'
                render={() => (
                  <div style={{ width: '100%' }}>
                    <StudiesSearchSelect onStudySelected={handleStudySelected} selectedStudies={selectedStudy ? [selectedStudy] : []} placeholder='Buscar estudios...' label='' disabled={false} minSearchLength={1} keepLabel={false} />
                  </div>
                )}>
                <Label text='Estudio' />
              </FormItem>
            </Form>
            <ToolbarItem toolbar='bottom' location='after'>
              <div className='form-popup-buttons-container'>
                <Button text='Cancelar' stylingMode='contained' onClick={handleModalShowFilter} />
                <Button text='Aplicar' stylingMode='contained' type='default' onClick={handleApplyFilters} />
              </div>
            </ToolbarItem>
          </Popup>
        )}
      </div>
    </div>
  );
};

export default Index;
